import { motion } from "framer-motion";
import { Sofa, Home as HomeIcon, Package, HardHat } from "lucide-react";

const services = [
  { icon: Sofa, title: "Home & Furniture Delivery", desc: "Two-man white glove delivery for furniture, appliances and white goods — straight to the room of choice." },
  { icon: Package, title: "Courier & Pallet Delivery", desc: "Fast, reliable parcel and pallet delivery for retailers and e-commerce brands, any size load." },
  { icon: HomeIcon, title: "Man & Van / Removals", desc: "Careful, affordable house and office removals with full loading, transport and unloading." },
  { icon: HardHat, title: "Construction & Site Delivery", desc: "Materials and equipment delivered straight to site, on schedule, every time." },
];

export const Services = () => (
  <section id="services" className="py-20 sm:py-24 bg-white">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <p className="text-xs sm:text-sm uppercase tracking-[0.2em] font-bold text-blue-600 mb-4">What we do</p>
      <h2 className="text-4xl sm:text-5xl tracking-tight font-semibold text-slate-900 max-w-2xl">
        Vans and crews for every sector
      </h2>
      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-testid="services-grid">
        {services.map((s, i) => (
          <motion.div key={s.title} data-testid={`service-card-${i}`}
            initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
            className="bg-white border border-slate-200 rounded-lg p-7 shadow-[0_2px_8px_rgba(15,23,42,0.04)] hover:shadow-[0_8px_24px_rgba(15,23,42,0.08)] hover:-translate-y-1 transition-all duration-300">
            <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-cyan-400 to-blue-600 flex items-center justify-center text-white mb-5">
              <s.icon size={22} />
            </div>
            <h3 className="text-xl font-medium text-slate-900">{s.title}</h3>
            <p className="mt-3 text-sm text-slate-600 leading-relaxed">{s.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
